export const FORGOT_PASSWORD_BEGIN = 'forgot_password_begin';
export const FORGOT_PASSWORD_REQUESTING = 'forgot_password_requesting';
export const FORGOT_PASSWORD_SUCCESS = 'forgot_password_success';
export const FORGOT_PASSWORD_ERROR = 'forgot_password_error';
export const FORGOT_PASSWORD_RESET = 'forgot_password_reset';